// Agents allowed to replace dry (seco) lines on locked orders (stock breakage).
export default [
  'elena@foodforjoe.es',
  'noelia@foodforjoe.es',
  'laura.diaz@foodforjoe.es',
];
